import styled from 'styled-components';

interface StatusBoxProps {
  status?: string;
}

const getBoxColor = (status?: string) => {
  switch (status) {
    case 'NOT_AVAILABLE':
      return 'black';  // 검은색
      
    case 'IN_PROGRESS':
        return 'black';  // 기본 검은색

      case 'COMPLETE':
        return '#2282E9';  // 파란색
        
      case 'SUBMITTED':
        return'#2282E9';  // 기본 검은색

      case 'APPROVED_EDITABLE':
        return '#2282E9';  // 파란색

      case 'APPROVED_FINAL':
        return'#2282E9';  // 파란색

      case 'REJECTED':
        return '#FF0000';  // 빨간색

    case 'true':  // 4번째 '견적 확인' 버튼 용
        return '#2282E9';  // 파란색

      default:
        return 'black';  // 기본 검은색
  }
};

const StyledStatusBox = styled.div<{ status?: string }>`
   width: 8px;
  height: 100%;
  background-color: ${({ status }) => {
    const color = getBoxColor(status);
    return color;
  }};
   border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex-shrink: 0;
  position: absolute;
  left: 0;
  top: 0;
  
  @media (min-width: 768px) {
    width: 12px;
}
`;

export const StatusBox = ({ status }: StatusBoxProps) => {
  return <StyledStatusBox status={status} />;
}; 



